import { Menu } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconUsers } from "@tabler/icons-react";
import CrewRotationModal from "src/generator/_Modals/CrewRotationModal/CrewRotationModal";
import { useCheckPerm, useIsOnline } from "src/hooks";
import { useSelector } from "src/redux/hooks";

const CrewRotationButton = () => {
  const [opened, { open, close }] = useDisclosure(false);
  const checkPerm = useCheckPerm();
  const isOnline = useIsOnline();
  const crewRotation = useSelector(
    state => state.generatorSlice.lbentry.crewRotation,
  );

  if (!crewRotation || !checkPerm("editeuser")) {
    return <></>;
  }

  return (
    <>
      <Menu.Item
        disabled={!isOnline}
        onClick={open}
        leftSection={<IconUsers size={20} />}>
        Crew Rotation
      </Menu.Item>
      {opened && <CrewRotationModal opened={opened} close={close} />}
    </>
  );
};

export default CrewRotationButton;
